// Copyright (c) 2020-2024 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { Tooltip } from '@mui/material';

export interface EllipsisProps {
  className?: string;
  classes?: Record<string, any>;
  text: string | number | React.ReactNode;
  tooltipText?: string;
  component?: React.ComponentType<any>;
  componentProps?: any;
  width?: string | number;
  maxWidth?: string | number;
  withTooltip?: boolean;
}

const Ellipsis: React.FC<EllipsisProps> = (props: EllipsisProps) => {
  const { 
    width, 
    maxWidth, 
    text, 
    tooltipText, 
    withTooltip = true, // default parameter to replace Ellipsis.defaultProps (deprecated).
    component: Component, 
    componentProps 
  } = props;
  const classes = withStyles.getClasses(props);
  const contentStyles = Component
    ? { maxWidth: '100%' }
    : { width, maxWidth };

  const content = (
    <>
      {withTooltip
        ? (
          <Tooltip placement="top-start" title={tooltipText || String(text) || ''}>
            <div style={contentStyles} className={classes.root}>{text}</div>
          </Tooltip>
        )
        : <div style={contentStyles} className={classes.root}>{text}</div>
      }
    </>
  );

  if (Component) {
    return (
      <Component style={{ width, maxWidth }} {...componentProps}>
        {content}
      </Component>
    );
  }

  return content;
};

// Ellipsis.defaultProps = {
//   withTooltip: true,
// };

const EllipsisStyled = withStyles(
  Ellipsis, 
  (theme, props) => ({
    "root": {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: 15,
    }
  })
);

export default EllipsisStyled;